<template>
    <div>
        <rkm-timeline>
            <rkm-timeline-item
                v-for="(item, i) in data.additionals.timeline"
                :key="i"
                :dateTime="item.dateTime"
                :title="item.title"
                :label="item.label"
                :disabled="item.disabled"
                :line-class="getTimeLineClass(item, i)"
            />
        </rkm-timeline>

        <rkm-form ref="RkmForm">

            <box-paciente :data="data" :disabledAcidenteTrabalho="true" />

            <box-alergia :data="data" />

            <box-medicamento-uso-continuo :data="data" />

            <box-fator-risco :data="data" />

            <box-sinal-vital :data="data" />

            <box-exames
                class="mt-4"
                :data="data"
                :addEnable="enableAddExame"
            />

            <box-observacao-geral :data="data" />

            <box-protocolo :data="data" :disabled="true" v-if="data.model.dorToracica" />

            <box-setor-encaminhamento
                v-if="showSetorEncaminhamento"
                :data="data" class="mt-4"
            />
        </rkm-form>
    </div>
</template>

<script>
// Vuex
import { mapActions } from 'vuex'

// Components.
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxMedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'
import BoxExames from '@/components/pronto-atendimento/components/exame/Index'
import BoxObservacaoGeral from '@/components/pronto-atendimento/components/observacao-geral/Index'
import BoxPaciente from '@/components/pronto-atendimento/components/paciente/Index'
import BoxProtocolo from '@/components/pronto-atendimento/components/protocolo/Index'
import BoxSetorEncaminhamento from '@/components/pronto-atendimento/components/setor-encaminhamento/Index'
import BoxFatorRisco from '@/components/pronto-atendimento/components/fator-risco/Index'
import BoxSinalVital from '@/components/pronto-atendimento/components/sinal-vital/Index'

// Mixins.
import { error, repository, stringCase, object, unmask } from '@/mixins'

// enums
import tipoExame from '@/enums/parametrizacao/tipoExame'
import statusExame from '@/enums/pronto-atendimento/statusExame'
import desfecho from '@/enums/pronto-atendimento/desfecho'

export default {
    components: {
        BoxAlergia,
        BoxMedicamentoUsoContinuo,
        BoxExames,
        BoxObservacaoGeral,
        BoxPaciente,
        BoxProtocolo,
        BoxSetorEncaminhamento,
        BoxFatorRisco,
        BoxSinalVital,
    },
    computed: {
        enableAddExame() {

            if (this.data.additionals.hasAtendimentoMedico) return false

            return this.data.form.recepcao.isEncaminhamento
                || (!this.data.form.recepcao.isEncaminhamento && !this.data.additionals.hasAtendimentoMedico)
        },
        showSetorEncaminhamento() {

            if (this.data.additionals.isPacienteEmObservacao) {

                return false
            }
            else if (this.data.additionals.hasAtendimentoMedico) {

                return true
            }
            else {

                return !this.data.form.recepcao.isEncaminhamento
            }
        }
    },
    created() {

        this.repositories = {
            exameImagem: this.getConectaSusRepository('prontoAtendimento.exameImagem'),
        }
    },
    data: () => ({
        enums: { tipoExame, statusExame, desfecho },
    }),
    methods: {
         ...mapActions(['setLoading', 'unsetLoading']),
        getTimeLineClass(item, i) {

            return item.listClass
                || this.data.additionals.timeline[i - 1] && this.data.additionals.timeline[i - 1].listClass
        },
        save(finalizacao = null) {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.data.model.pedidosExames.length === 0) {

                        if(!this.data.additionals.hasAtendimentoMedico){

                            return this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: 'É obrigatório adicionar pelo menos um exame.'
                            })
                        }
                    }

                    let request = {}

                    if(finalizacao) {

                        if (this.hasSomeExameSolicitadoOrAguardandoResultado()) {

                            return this.createNotification({
                                type: 'alert',
                                color: 'danger',
                                title: 'Ação não permitida',
                                message: 'Finalização do atendimento não permitida, um ou mais exames não foram realizados.'
                            })
                        }

                        request.finalizacao = finalizacao
                    }

                    if (this.hasSomeExameSolicitadoOrAguardandoResultado()) {

                        this.showConfirmation(
                            'Há um ou mais exames de imagem pendentes. Se continuar com o encaminhamento, '
                                + 'o exame de imagem continuará pendente. Deseja continuar?',
                            async () => this.store(request),
                        )
                    }
                    else {

                        this.store(request)
                    }
                })
        },
        store(request) {

            this.setLoading()

            request = Object.assign(request, {
                plantaoId: this.plantaoId,
                atendimentoId: this.data.form.atendimentoId,
                centroCustoIdPara: this.data.model.centroCustoIdPara ?? null,
                observacoes: this.data.model.observacoes,
                fatoresRisco: this.data.model.fatoresRisco,
                fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => {
                    return {
                        medicamentoId: item.medicamento.id,
                    }
                }),
                sinaisVitais: this.data.model.sinaisVitais.map(item => {
                    return {
                        pa: item.pa || null,
                        paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                        glicemia: item.glicemia || null,
                        temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                        pulso: item.pulso || null,
                        respiracao: item.respiracao || null,
                        saturacao: item.saturacao || null,
                        intensidadeDor: item.intensidadeDor || null,
                        cintura: item.cintura || null,
                    }
                }),
                pedidosExames: this.data.model.pedidosExames.map(item => {

                    let exame = item.exames.map(exame => {
                        return {
                            disabled: exame.disabled,
                            id: exame.id,
                            exameId: exame.exame.id,
                            observacao: exame.observacao ?? null,
                            horarioRealizacao: exame.horarioRealizacao ?? null,
                            statusId: exame.status.id
                        }
                    })

                    const pedido = {
                        isForm: item.isForm,
                        id: item.id,
                        urgente: item.urgente,
                        justificativa: item.justificativa ?? null,
                        exames: exame,
                        lotacaoExecutanteId: item.lotacaoExecutanteId,
                        files: item.files.filter(f => (f instanceof File)),
                    }

                    if (this.data.form.recepcao.isEncaminhamento
                        && !this.data.additionals.hasAtendimentoMedico) {

                        pedido.dataSolicitacao = item.dataSolicitacao
                        pedido.unidadeEncaminhamentoId = item.unidadeEncaminhamentoId
                        pedido.unidadeExternaEncaminhamentoId = item.unidadeExternaEncaminhamentoId
                        pedido.medicoSolicitanteEncaminhamento = item.medicoSolicitanteEncaminhamento
                    }

                    return pedido
                }),
            })

            const formData = this.objectToFormData(this.camelObjectKeysToSnakeRecursive(request))

            this.repositories.exameImagem.store(formData)
                .then(() => {
                    this.showSaveNotification()
                    this.$emit('save')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        liberaPaciente() {

            let finalizacao = null

            finalizacao = {
                desfecho_id: this.enums.desfecho.PACIENTE_LIBERADO,
            }

            this.save(finalizacao)
        },
        hasSomeExameSolicitadoOrAguardandoResultado() {

            return this.data.model.pedidosExames.some(item => {

                return item.exames.some(exame => {

                    return exame.status.id === this.enums.statusExame.SOLICITADO
                        || exame.status.id === this.enums.statusExame.AGUARDANDO_RESULTADO
                })
            })
        }
    },
    mixins: [ error, repository, stringCase, object, unmask ],
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
}
</script>